// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-257398cf]{font-weight:700;line-height:2.0625rem}@media(min-width:576px){h1[data-v-257398cf]{font-size:24px;font-size:1.5rem}}@media(min-width:768px){h1[data-v-257398cf]{font-size:32px;font-size:2rem;line-height:2.6875rem}}@media(min-width:992px){h1[data-v-257398cf]{font-size:36px;font-size:2.25rem}}", ""]);
// Exports
module.exports = exports;
